var map = {
	"./br.svg": 73694,
	"./de.svg": 25339,
	"./es.svg": 38946,
	"./fr.svg": 26266,
	"./gb.svg": 19753,
	"./globe.svg": 37185,
	"./it.png": 77651,
	"./it.svg": 73473,
	"./line.png": 20574,
	"./mail.svg": 10823,
	"./ru.svg": 86513,
	"./search.svg": 75514,
	"./uk.svg": 2106,
	"./whatsapp.svg": 51324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66470;